import { isAfter, isBefore, isSameDay, isValid, startOfDay } from 'date-fns'

export const defaultTimeParts = () => [12, 0, 0, 0] as const;

export const getTomorrowDate = () => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(...defaultTimeParts())

  return tomorrow
}

export const MsPerDay = 1000 * 60 * 60 * 24

type DateLike = string | number | Date | null | undefined

const toDate = (value: DateLike) => {
  if (value === null || value === undefined || value === '') return null

  const date = new Date(value)

  return isValid(date) ? date : null
}

export const isDateInPast = (value: DateLike) => {
  const date = toDate(value)

  return date !== null && isBefore(startOfDay(date), startOfDay(new Date()))
}

export const isDateInFuture = (value: DateLike) => {
  const date = toDate(value)

  return date !== null && isAfter(startOfDay(date), startOfDay(new Date()))
}

export const isSameCalendarDate = (value: DateLike, comparedTo: DateLike) => {
  const date = toDate(value)
  const comparedDate = toDate(comparedTo)

  return date !== null && comparedDate !== null && isSameDay(date, comparedDate)
}

export const isBeforeDate = (value: DateLike, comparedTo: DateLike) => {
  const date = toDate(value)
  const comparedDate = toDate(comparedTo)

  return date !== null && comparedDate !== null && isBefore(startOfDay(date), startOfDay(comparedDate))
}

export const getCurrentDate = (): Date => {
  const now = new Date();
  now.setHours(...defaultTimeParts())

  return now;
}
